import React from 'react';

import { CreateTotpRequest } from '@/DTOs/totp';
import { TOTPResult } from '@/hooks/useTOTP';
import { useTranslator } from '@/hooks/useTranslator';

type SubmitFn = (data: CreateTotpRequest) => void;
type ErrorFn = (value: string) => void;

type TOTPValidationResult = (
  submit: SubmitFn,
  error: (value: string) => void,
) => (event: React.FormEvent) => void;

export const useTotpSubmitHandler = (totp: TOTPResult): TOTPValidationResult => {
  const tr = useTranslator();

  return React.useCallback(
    (submit: SubmitFn, error: ErrorFn): ((event: React.FormEvent) => void) => {
      return async (event: React.FormEvent): Promise<void> => {
        event.preventDefault();

        const form = event.currentTarget;
        if (!(form instanceof HTMLFormElement)) {
          return;
        }
        const { elements } = form;

        const codeInput = elements.namedItem(totp.secret);
        if (!(codeInput instanceof HTMLInputElement)) {
          return;
        }

        const code = codeInput.value;
        if (!totp.validate(code)) {
          error(tr('INVALID_OTP'));
          return;
        }

        submit({
          secret: totp.secret,
          digits: totp.digits,
          period: totp.period,
          algorithm: `Hmac${totp.algorithm}`,
        });
      };
    },
    [totp, tr],
  );
};
